import en from './en.json';
import zhCN from './zh-CN.json';
import { getCurrentLanguage, SupportedLanguage } from '@/services/languageService';

// 翻译资源
const translations = {
  en,
  'zh-CN': zhCN
};

/**
 * 获取翻译函数
 * @returns 翻译函数
 */
export const getTranslation = () => {
  return (key: string, params?: Record<string, string>) => {
    // 使用languageService中的全局语言
    const currentLanguage = getCurrentLanguage();
    
    // 安全地获取翻译，处理可能的未定义情况
    let translation = key;
    try {
      // 确保currentLanguage是字符串并且是translations的有效键
      if (typeof currentLanguage === 'string' && translations[currentLanguage as keyof typeof translations]) {
        const langTranslations = translations[currentLanguage as keyof typeof translations];
        if (langTranslations && typeof key === 'string' && key in langTranslations) {
          translation = langTranslations[key];
        } else if (translations.en && typeof key === 'string' && key in translations.en) {
          // 回退到英语
          translation = translations.en[key];
        }
      } else if (translations.en && typeof key === 'string' && key in translations.en) {
        // 回退到英语
        translation = translations.en[key];
      }
    } catch (error) {
      console.error(`翻译错误，键: ${key}`, error);
    }
    
    // 处理参数替换
    if (params && typeof translation === 'string') {
      return Object.entries(params).reduce(
        (text, [paramKey, value]) => {
          if (typeof text === 'string' && typeof paramKey === 'string' && value !== undefined) {
            return text.replace(`{${paramKey}}`, String(value));
          }
          return text;
        },
        translation
      );
    }
    
    return translation;
  };
}; 